import toasterManager from 'common/Toaster/ConfirmManager'

export default {
  confirm: options => toasterManager.open(options),
}
